import React from 'react';

import useCioBrowseAndGqlProducts from '../hooks/useCioBrowseAndGqlProducts';
import useInGridAssets from '../hooks/useInGridAssets';

import MobileGridDiscoveryGuide from './MobileGridDiscoveryGuide';
import MobileGridHeader from './MobileGridHeader';
import MobileGridStickySideNavHeader from './MobileGridStickySideNavHeader';
import MobileGridVirtualScroll from './MobileGridVirtualScroll';

const MobileGridLayout = () => {
  const {
    products,
    totalNumResults,
    fetchNextPage,
    hasNextPage,
    isCioBrowseFetching,
  } = useCioBrowseAndGqlProducts();

  const { mergedAssetsAndProducts } = useInGridAssets({ products });

  // TODO: handle loading/error states, no results found
  return (
    <div className="px-[16px]">
      <MobileGridDiscoveryGuide />
      <MobileGridStickySideNavHeader />
      <MobileGridHeader />
      <MobileGridVirtualScroll
        virtualList={mergedAssetsAndProducts}
        totalNumResults={totalNumResults}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isCioBrowseFetching={isCioBrowseFetching}
      />
    </div>
  );
};

export default MobileGridLayout;
